import { FormikProps, useFormik } from "formik";
import { ChangeEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomerDetails } from "src/features/hq/customers/models";
import MembersPresenter from "./MembersPresenter";

type Props = {
  members: { [name: string]: string, role: string }[];
  update: (cutomerUpdates: Partial<CustomerDetails>) => void;
};

export type EditForm = {
  members: {
    [name: string]: string;
    role: string;
  }[];
};

export default function MembersContainer({ members, update }: Props) {
  const [searchParams] = useSearchParams();
  const [editing, setEditing] = useState(searchParams.get("edit") === "true");

  const mapper = ({ members }: EditForm) => ({
    band: { members: members.filter(m => !!m.name) }
  } as Partial<CustomerDetails>);

  const submitUpdates = (updates: EditForm) => update(mapper(updates));

  const handeChange = (index: number, property: string) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      const updatedMembers = formik.values.members;
      formik.setFieldValue('members', updatedMembers.map((m, i) => {
        if (i === index) {
          return {
            ...m,
            [property]: event.target.value
          }
        }
        return m;
      }));
    }

  const removeMember = (index: number) => {
    const newMembers = formik.values.members.filter((_, i) => i !== index);
    formik.setFieldValue('members', newMembers);
  }

  const addMember = () => {
    const newMembers = [...formik.values.members, { name: '', role: '' }];
    formik.setFieldValue('members', newMembers);
  }

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      members: [...members, { name: '', role: '' }]
    },
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  return <MembersPresenter
    formik={formik}
    handeChange={handeChange}
    editing={editing}
    setEditing={setEditing}
    removeMember={removeMember}
    addMember={addMember}
  ></MembersPresenter>;
}